<template>
    <div class="shopping-cart">
      <van-popup
        v-model="messageShowtval"
        closeable
        round
        position="bottom"
        :style="{ height: '85%' }"
        @close="childMethod()"
      >
        <div class="cart-list">
          <div class="title">用药信息</div>
          <ul class="cart-box cart-box2">
            <li>
              <div class="cart-left">
                <div class="goods-name">
                <div class="goodsName">
                  <span v-show="parseInt(newListData.prescriptionYn) === 1">处方药</span>
                  {{ newListData.commonName }}
                </div>
              </div>
              <p id="ellipsis_client">
                {{ newListData.attributeSpecification }}
              </p>
                <p v-if="newListData.drugChannel == 1">{{ newListData.manufacturer || '' }}</p>
              </div>
              <div class="cart-right" style="width: 125px;">
                <p>
                  <van-stepper
                    v-model="quantityValue"
                    button-size="30px"
                    min="1"
                    :disable-plus="this.newListDataQuantity > newListData.stockNumber - 1 && checkStockNumber"
                    theme="round"
                    @minus="minus"
                    @blur="blur"
                    @plus="plus"
                    integer
                    :disable-minus="newListData.num == 1"
                    @overlimit="overlimit"
                    disable-input
                    style="width: 115px; display: inline-block;"
                  />
                  <span v-show="newListData.num > 0" class="usage_text">{{ newListData.unitName }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div class="field-box">
          <van-cell-group>
            <van-field
                label="用药方法"
                placeholder="请选择"
                is-link
                :value="methodActive"
                disabled
                :border="true"
                @click="toMethod"
            />
          </van-cell-group>
        </div>
        <div class="field-box">
          <van-cell-group>
            <van-field
              v-if="unitActive != '适量'"
              label="单次用量"
              :value="drugDosage"
              placeholder="请输入"
              :border="true"
              disabled
              right-icon="arrow"
              @click="SelectedDrugDosage"
            />
            <van-field
              v-else
              label="单次用量"
              value="“每次适量用药”该栏无需填写"
              :border="true"
              disabled/>
          </van-cell-group>
        </div>
        <div class="field-box">
          <van-cell-group>
            <van-field
                label="剂量单位"
                placeholder="请选择"
                is-link
                :value="unitActive"
                disabled
                :border="true"
                @click="SelectedUnit"
            />
          </van-cell-group>
        </div>
        <div class="field-box">
          <van-cell-group>
            <van-field
              label="用药频率"
              :value="drugActive"
              placeholder="请选择"
              :border="true"
              disabled
              right-icon="arrow"
              @click="toRate"
            />
          </van-cell-group>
        </div>
        <!-- <div class="message-but" @click="messageBut"> -->
        <van-button type="info" class="editSubmit" round @click="messageBut(true)">确定</van-button>
        <!-- </div> -->
      </van-popup>
      <!--选择方法-->
      <van-popup v-model="isActiveMethod" position="right" :overlay="false" :style="{ width: '100%', height: '100%' }" >
        <van-nav-bar title="用药方法" left-text="取消" right-text="清除" fixed @click-left="unitMethod(1)" @click-right="clearUnitMethod" />
        <ul class="unit-box">
          <li
            v-for="(item, index) in methodData"
            :key="index + item.name"
            :class="{ unitActive: methodActive === item.name }"
            @click="unitMethod(item.name, item.value)"
          >{{ item.name }}</li>
        </ul>
      </van-popup>
      <!--选择频率-->
      <van-popup v-model="isActiveRate" position="right" :overlay="false" :style="{ width: '100%', height: '100%' }" >
        <van-nav-bar title="用药频率" left-text="取消" right-text="清除" fixed @click-left="unitRate(1)" @click-right="clearUnitRate"/>
        <ul class="unit-box" v-if="usedrugData2.length > 0">
          <li
            v-for="(item, index) in usedrugData2"
            :key="index + item.name"
            :class="{ unitActive: drugActive === item.name }"
            @click="unitRate(item.name, item.value)"
          >{{ item.name }}</li>
        </ul>
        <ul class="unit-box" v-else>
          <li
            v-for="(item, index) in usedrugData"
            :key="index + item.name"
            :class="{ unitActive: drugActive === item.name }"
            @click="unitRate(item.name, item.value)"
          >{{ item.name }}</li>
        </ul>
      </van-popup>
      <!--选择单位-->
      <van-popup v-model="isActive" position="right" :overlay="false" :style="{ width: '100%', height: '100%' }" >
        <van-nav-bar title="选择单位" left-text="取消" right-text="清除" fixed @click-left="unitSelected(1)" @click-right="clearUnitSelected"  />
        <ul class="unit-box">
          <li
            v-for="(item, index) in unitData"
            :key="index + item.name"
            :class="{ unitActive: unitActive === item.name }"
            @click="unitSelected(item.name, item.value)"
          >{{ item.name }}</li>
        </ul>
      </van-popup>
      <!--选择用量-->
      <van-popup v-model="isActiveDosage" position="right" :overlay="false" :style="{ width: '100%', height: '100%' }" >
        <van-nav-bar
          title="用量"
          left-text="取消"
          fixed
          right-text="完成"
          @click-left="unitDosageSelected(1)"
          @click-right="handleDone"
          style="background:white"
        />
        <div
          class="textarea-wrap"
          style="width:calc(100% - 40px);margin-left:20px;background:rgba(248,248,248,1);border-radius:8px; overflow:hidden"
        >
          <van-field
            v-model="drugDosageInside"
            rows="3"
            autosize
            type="textarea"
            placeholder="请输入单次用量，仅输入数字"
            style="width:calc(100% - 40px);background:rgba(248,248,248,1);"
          />
        </div>
        <div class="unit-list-tip" style="font-size: 14px; padding-left: 20px;padding-top: 10px; color: rgba(51, 51, 51, 1);">注：若“每次适量用药”输入框无需填写</div>
        <div class="unit-list-tip" style="font-size: 14px; padding-left: 20px;padding-top: 10px; color: #EF595E;" v-if="newListData.hasShow">*推荐单次用量{{ newListData.minSingleDose }}-{{ newListData.maxSingleDose }}{{ newListData
        .singleUnit }}</div>
      </van-popup>
    </div>
  </template>
  <script>
  import { reverseData } from "@/utils/mapping";
  import {Toast} from "vant";
  export default {
    props: {
      newListData: {
        type: Object,
        default: () => {
          return {
            quantityValue: ''
          };
        }
      },
      messageShowt: {
        type: Boolean,
        default: false
      },
      usedrugData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      usedrugData2: {
        type: Array,
        default: () => {
          return [];
        }
      },
      unitData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      methodData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      // 药品库存是否校验
      checkStockNumber: {
        type: Boolean,
        default: false,
      },
      dosageData: {
        type: Array,
        default: () => {
          return [];
        }
      },
      inquiryType: {
        type: Number,
        default: null,
      },
      inquirySource: {
        type: Number,
        default: null,
      },
      isChildInquiry: Boolean, // 是否为儿童问诊
    },
    data() {
      return {
        newListDataQuantity: 1,
        isComplete: true, // 用法用量是否是全的
        drugDosageInside: "",
        isActive: false, // 判断选择单位
        isActiveDosage: false, // 判断选择用量
        isActiveRate: false,
        isActiveMethod: false,
        drugActive: "请选择", // 获取用药频率
        methodActive: "请选择", // 获取用药方法
        unitActive: "", // 获取单位
        quantityValue: this.newListData.num, // 药品个数
        drugDosage: "", // 获取用量
        messageShowtval: this.messageShowt, // 弹框是否显示
        duration: 1000, // toast消失时间
        shoppingData: {
          productPref: "", // 商品编号
          productName: "", // 商品名称
          productUnitId: "", // 商品单位
          quantity: 1, // 商品数量
          useFrequency: "", // 使用频率
          singleDose: "", // 单次剂量
          singleUnit: "", // 单次剂量单位
          directions: "", // 用药方法
          productPrice: 0, // 商品价格
          attributeSpecification: "", // 商品规格
          manufacturer: "", // 生产厂家
          producingArea: "", // 商品产地
          productSystemType: "", // 商品系统类型
          medicinesQuasiName: "", // 国药准字号
          medicinesPackageUtil: "", // 包装单位
          useExplain: "", // 使用说明
          prescriptionYn: "", // 判断是否是处方  1-是 0-不是
          stockNumber: "", // 商品库存数
          drugChannel: 0, // 0 中台，1品牌
          categoryId: '', // 类别
        }
      };
    },
    computed: {
    },
    created() {
      // const {
      //   useFrequency,
      //   singleDose,
      //   singleUnit,
      //   directions
      // } = this.newListData;
      // console.log("添加当前项=", this.newListData);
      // if (useFrequency && directions && singleDose && singleUnit) {
      //   this.isComplete = true;
      // }
    },
    watch: {
      messageShowt(val) {
        this.shoppingData = reverseData(
          this.shoppingData, // 购物车数据字段
          this.newListData, // 点击添加的商品项
          this.rules()
        );
        console.log(this.shoppingData);
        this.messageShowtval = val;
        this.shoppingData = reverseData(
          this.shoppingData, // 购物车数据字段
          this.newListData, // 点击添加的商品项
          this.rules()
        );
        this.drugActive =
          this.newListData.useFrequencyZh ||
          this.newListData.useFrequency ||
          "请选择"; // 频率
        this.methodActive = this.newListData.directions || "请选择";
        this.unitActive = this.newListData.singleUnit;
        this.drugDosage = this.drugDosageInside =
          this.newListData.singleDoseZh || this.newListData.singleDose;
          this.quantityValue= this.newListData.num;
          
      }
    },
    methods: {
      overlimit() {
      return this.$toast({
          message: '药品数量最小为1'
      })
    },
      minus() {
        let quantity = this.quantityValue;
        console.log(`shopping-message-点击减号`);
        quantity--;
        this.changeValue(quantity);
      },
      blur() {
        let quantity = this.quantityValue;
        this.changeValue(quantity);
      },
      plus() {
        let quantity = this.quantityValue;
        console.log(`shopping-message-点击加号`);
        quantity++;
        if (
          (this.inquiryType === 2 || this.inquiryType === 4) &&
          this.inquirySource != 10
        ) {
          if (this.newListData.totalDosageLimit > 0 && quantity > this.newListData.totalDosageLimit) {
            quantity = this.newListData.totalDosageLimit;
            this.$toast("药品超过最大安全用量");
          }
        }
        this.changeValue(quantity);
      },
      // 修改商品个数
      changeValue(quantity) {
        console.log(`shopping-message-更新药品数量显示`);
        this.$nextTick(() => {
          console.log(`shopping-message-nextTick更新药品数量显示`);
          this.$set(this.newListData, 'quantityValue', quantity);
          this.quantityValue = quantity
          this.newListDataQuantity = this.newListData.quantityValue
        })
      },
      prohibitAddDrug(item) {
        if (item.quantityValue > item.stockNumber - 1 && this.checkStockNumber) {
          Toast("当前药品库存不足");
        }
      },
      handleDone() {
        const reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        const result = reg.test(this.drugDosageInside);
        if (result) {
          this.$toast({
            duration: 2000,
            message: "不可输入汉字"
          });
          return false;
        }
        if (this.drugDosageInside && this.drugDosageInside.length > 10) {
          this.$toast({
            duration: 2000,
            message: "限制10字符以内"
          });
          return false;
        }
        if(this.newListData.hasShow) {
           if(this.drugDosageInside < this.newListData.minSingleDose ||this.drugDosageInside >  this.newListData.maxSingleDose ) {
           Toast(`药品推荐单次用量${this.newListData.minSingleDose}-${this.newListData.maxSingleDose}${this.newListData.singleUnit}`);
            return ;
          }
        }
        this.drugDosage = this.drugDosageInside;
        this.newListData.singleDose = this.drugDosageInside;
        this.newListData.singleDoseValue = this.drugDosageInside;
        this.newListData.singleDoseZh = this.drugDosageInside;
        this.isActiveDosage = false;
      },
      /**
       * @description:点击关闭方法
       * @param: {}
       * @param: {}
       * @return: void
       */
      unitMethod(name, value) {
        if (name !== 1) {
          this.methodActive = name;
          this.newListData.directions = name;
        }
        this.isActiveMethod = false;
      },
      /**
       * @description:点击清除用药方法
       * @param: {}
       * @return: void
       */
      clearUnitMethod() {
        this.methodActive = '';
        this.newListData.directions = '';
        this.isActiveMethod = false;
      },
      /**
       * @description:点击用药方法
       * @return: void
       */
      toMethod() {
        if(this.newListData.hasShow) return ; // 后端带出的药品 不能编辑
        this.isActiveMethod = true;
      },
      /**
       * @description:点击用药频率
       * @return: void
       */
      toRate() {
        this.isActiveRate = true;
      },
      /**
       * @description:点击关闭频率
       * @return: void
       */
      unitRate(name, value) {
        if (name !== 1) {
          this.drugActive = name;
          this.newListData.useFrequency = name;
          this.newListData.useFrequencyValue = value;
          this.newListData.useFrequencyZh = name;
        }
        this.isActiveRate = false;
      },
      /**
       * @description:点击清除用药频率
       * @param: {}
       * @return: void
       */
      clearUnitRate() {
        this.drugActive = '';
        this.newListData.useFrequency = '';
        this.newListData.useFrequencyValue = '';
        this.newListData.useFrequencyZh = '';
        this.isActiveRate = false;
      },
      // 添加时判断库存数不足
      // quantityBlur() {
      //   if (this.quantityValue > this.newListData.stockNumber) {
      //     this.$toast({
      //       duration: this.duration,
      //       message: '库存数不足'
      //     })
      //     this.quantityValue = 1
      //     return
      //   }
      // },
      childMethod(data) {
        // 关闭弹框
        this.shoppingData = {
          productPref: "", // 商品编号
          productName: "", // 商品名称
          productUnitId: "", // 商品单位
          quantity: 1, // 商品数量
          useFrequency: "", // 使用频率
          singleDose: "", // 单次剂量
          singleUnit: "", // 单次剂量单位
          directions: "", // 用药方法
          productPrice: 0, // 商品价格
          attributeSpecification: "", // 商品规格
          manufacturer: "", // 生产厂家
          producingArea: "", // 商品产地
          productSystemType: "", // 商品系统类型
          medicinesQuasiName: "", // 国药准字号
          medicinesPackageUtil: "", // 包装单位
          useExplain: "", // 使用说明
          prescriptionYn: "", // 判断是否是处方  1-是 0-不是
          stockNumber: "", // 商品库存数
          drugChannel: 0, // 0 中台，1品牌
          categoryId: '', // 类别
        };
        this.methodActive = "";
        this.drugActive = "";
        this.quantityValue = 1;
        this.unitActive = "";
        this.drugDosage = "";
        this.$emit("closemessage", data);
      },
      // 点击关闭选择单位
      unitSelected(name, value) {
        if (name !== 1) {
          this.unitActive = name;
          this.newListData.singleUnit = name;
          this.newListData.singleUnitValue = value;
          if (value == '适量') {
            this.newListData.singleDose = '';
            this.newListData.singleDoseValue = '';
            this.newListData.singleDoseZh = '';
          } else {
            this.newListData.singleDose = this.drugDosage;
            this.newListData.singleDoseValue = this.drugDosage;
            this.newListData.singleDoseZh = this.drugDosage;
          }
        }
        this.isActive = false;
      },
      // 清除选择单位
      clearUnitSelected() {
        this.unitActive = '';
        this.newListData.singleUnit = '';
        this.newListData.singleUnitValue = '';
        this.isActive = false;
      },
      // 点击关闭选择用量
      unitDosageSelected(name, value) {
        if (name !== 1) {
          this.drugDosage = name;
          this.newListData.singleDose = name;
          this.newListData.singleDoseValue = value;
          this.newListData.singleDoseZh = name;
        }
        this.isActiveDosage = false;
      },
      // 点击选择单位
      SelectedUnit() {
        if(this.newListData.hasShow) return ; // 后端带出的药品 不能编辑
        this.isActive = true;
      },
      // 点击选择用量
      SelectedDrugDosage() {
        this.isActiveDosage = true;
      },
      messageBut(check, q, flag) {
        console.log("传进来的flag=", flag);
        if (flag === false) {
          this.isComplete = flag;
        }
        console.log("********", q);
        if (this.drugActive === "" && !check) {
          this.$toast({
            duration: this.duration,
            message: "请选择用药频率"
          });
          return;
        }
        if (this.drugDosage === "" && !check) {
          this.$toast({
            duration: this.duration,
            message: "请选择单次用量"
          });
          return;
        }
        if (this.unitActive === "" && !check) {
          this.$toast({
            duration: this.duration,
            message: "请选择药品单位"
          });
          return;
        }
        if (this.methodActive === "" && !check) {
          this.$toast({
            duration: this.duration,
            message: "请选择用药方法"
          });
          return;
        }
  
        this.shoppingData = reverseData(
          this.shoppingData, // 购物车数据字段
          q || this.newListData, // 点击添加的商品项
          this.rules()
        );
  
        let shopData = q || this.newListData; // $ref 调用超前于prop数据更新
  
        // 处理用法用量输入结果
        this.shoppingData.directions = shopData.directions || '';
        this.shoppingData.useFrequency = shopData.useFrequency || '';
        this.shoppingData.useFrequencyValue = shopData.useFrequencyValue || '';
        this.shoppingData.singleDose = shopData.singleDose || '';
        this.shoppingData.singleDoseValue = shopData.singleDose || '';
        this.shoppingData.singleUnit = shopData.singleUnit || '';
        this.shoppingData.singleDoseZh = shopData.singleDoseZh || '';
        this.shoppingData.singleUnitValue = shopData.singleUnitValue || '';
        this.shoppingData.useFrequencyZh = shopData.useFrequencyZh || '';
        this.shoppingData.quantity = this.quantityValue || '';
        
  
        console.log("iscomplete-------------------", this.isComplete);
        this.$emit("submitChangeList", this.shoppingData);
        if (!this.isComplete) {
          this.childMethod();
        } else {
          console.log("用法用量缺失，调用更新");
          this.childMethod(this.shoppingData);
        }
        this.drugDosageInside = "";
      },
      rules() {
        return [
          {
            key: "productPref",
            value: "pref"
          },
          {
            key: "productName",
            value: "commonName"
          },
          {
            key: "commonName",
            value: "productName"
          },
          {
            key: "productUnitId",
            value: "unitId"
          },
          {
            key: "quantity",
            value: "quantityValue"
          },
          {
            key: "attributeSpecification",
            value: "attributeSpecification"
          },
          {
            key: "manufacturer",
            value: "manufacturer"
          },
          {
            key: "medicinesPackageUtil",
            value: "unitName"
          },
          {
            key: "producingArea",
            value: "producingArea"
          },
          {
            key: "productPrice",
            value: "retailPrice"
          },
          {
            key: "productSystemType",
            value: "systemType"
          },
          {
            key: "medicinesQuasiName",
            value: "pharmacyPref"
          },
          {
            key: "useExplain",
            value: "remindContent"
          },
          {
            key: "prescriptionYn",
            value: "prescriptionYn"
          },
          {
            key: "stockNumber",
            value: "stockNumber"
          },
          {
            key: "instructionsDto",
            value: "instructionsDto"
          },
          {
            key: "useFrequency",
            value: "useFrequency"
          },
          {
            key: "singleDose",
            value: "singleDose"
          },
          {
            key: "directions",
            value: "directions"
          },
          {
            key: "singleUnit",
            value: "singleUnit"
          },
          {
            key: "singleDoseValue",
            value: "singleDoseValue"
          },
          {
            key: "useFrequencyValue",
            value: "useFrequencyValue"
          },
          {
            key: "type",
            value: "type"
          },
          {
            key: 'drugChannel',
            value: 'drugChannel'
          },
          {
            key: 'categoryId',
            value: 'categoryId'
          },
          { // 折扣标识
            key: 'discountRatioToShow',
            value: 'discountRatioToShow'
          },
          { // 标准库id
            key: "standardId",
            value: "standardId",
          },
          { // 药品总剂量限制
            key: "totalDosageLimit",
            value: "totalDosageLimit",
          },
        ];
      }
    }
  };
  </script>
  <style scoped lang="scss">
  #ellipsis_client {
    word-break: break-all;
    width: 190px;
    text-wrap: wrap;
    overflow-wrap: break-word;
    line-height: normal;
    height: auto;
  }
  .usage_text {
  width: 30px;
  font-size: 12px;
  transform: translateY(12px);
  margin-left: 5px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}
      .goods-name {
      line-height: 24px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      span {
        box-sizing: border-box;
        padding: 0 5px;
        height: 18px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(239, 77, 77, 1);
        line-height: 18px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(239, 77, 77, 1);
        text-align: center;
        margin-right: 6px;
      }
      .goodsName {
        font-size: 14px !important;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        display: block;
      }
    }
    .specifications {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 17px;
      margin: 5px 0 10px 0;
    }
  .editSubmit {
    width: 100%;
    margin-top:50px;
    border-color:#01B956;
    background-color: #01B956;
    color:white;
  }
  .shopping-cart /deep/ .van-nav-bar__right .van-nav-bar__text {
    color: #01B956;
    font-size: 15px;
    margin-left: -10px;
  }
  .shopping-cart /deep/ .van-nav-bar__text {
    color: #666;
    font-size: 15px;
    margin-left: -10px;
  }
  .unit-box {
    height: calc(100vh - 100px);
    overflow-y: scroll;
  }
  .field-box {
    padding-left: 20px;
    /deep/.van-cell {
      font-size: 16px !important;
      color: #333 !important;
      font-weight: 400;
      height: 64px;
      display: flex;
      align-items: center;
    }
    /deep/.van-field__control {
      text-align: right;
    }
  }
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-width: 1px 0;
  }
  .textarea-wrap {
    margin-top: 50px;
    background: rgba(248, 248, 248, 1);
  }
  ::v-deep .van-field--disabled .van-field__label{
    color:#646566;
  }
  /deep/.van-stepper__plus {
    background-color: #01B956 !important;
  }

  /deep/.van-stepper--round .van-stepper__minus {
    color: #01B956 !important;
    background-color: #fff;
    border: 0.02667rem solid #01B956;
}
  </style>
  